<template>
  <div class="header">
    <div class="user-center-container">
      <a-avatar style="margin-right:10px;font-size: 18px;" >
        <a-tooltip :title="$t('message.button.helpCenter')"><a href="/helpcenter" style="color:white"><a-icon type="question-circle"/></a></a-tooltip>
      </a-avatar>
      <a-dropdown style="margin-right:10px">
          <span>
            <a-avatar>
              <icon-font type="icon-feedback" style="font-size: 20px;color: white;margin-top: 7px;margin-left: 4px;"/>
            </a-avatar>
          </span>
        <a-menu slot="overlay">
          <a-menu-item>
            <a href="/feedback/dashboardScore">{{$t('message.menu.feedback.dashboardScore')}}</a>
          </a-menu-item>
          <a-menu-item>
            <a href="/feedback/systemFeedback">{{$t('message.menu.feedback.feedback')}}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <a-dropdown>
          <span>
            <a-avatar>CB</a-avatar>
             <a-icon type="down"/>
          </span>
        <a-menu slot="overlay">
          <a-menu-item>
            <a href="javascript:;">{{ $t('message.login.user_profile') }}</a>
          </a-menu-item>
          <a-menu-item>
            <a :href="logout">{{ $t('message.login.log_out') }}</a>
          </a-menu-item>
          <a-menu-item>
            <a href="/icp/task">{{ $t('message.login.task_center') }}</a>
          </a-menu-item>
          <a-sub-menu :title="$t('message.login.language')">
            <a-menu-item>
              <a @click="switchLocale('zh_CN')">{{ $t('message.login.switch_to_zh_cn') }}</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="switchLocale('en_US')">{{ $t('message.login.switch_to_en_us') }}</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="switchLocale('in_ID')">{{ $t('message.login.switch_to_in_id') }}</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="switchLocale('th_TH')">{{ $t('message.login.switch_to_th_th') }}</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="switchLocale('vi_VN')">{{ $t('message.login.switch_to_vi_vn') }}</a>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>
<script>
import Icon from 'ant-design-vue/es/icon'
import request from '../utils/request'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2733048_pwsnsjh4bsb.js'
})
export default {
  inject: ['reload'],
  data () {
    return {
      selected_option_id: '',
      app_options: [],
      dataSource: [],
      appSelection: false,
      accessMenuUrls: [],
      logout: this.merchantLogout()
    }
  },
  components: {
    IconFont
  },
  mounted () {
    this.getLocale()
  },
  methods: {
    switchLocale (locale) {
      this.setLocale(locale)
    },
    merchantLogout () {
      if (location.href.indexOf('pre') > -1) {
        return 'https://pre-allinone.ascp.alibaba.com/login/common/logout'
      }
      return 'https://login-cb.ascp.alibaba.com/login/common/logout'
    },
    getLocale () {
      request({
        url: '/user/locale',
        method: 'get'
      }).then(response => {
        if (response.data.success && response.data.model && response.data.model.length > 0) {
          console.log(response.data.model)
          localStorage.setItem('locale', response.data.model)
          this.$i18n.locale = response.data.model
        }
      })
    },
    setLocale (locale) {
      request({
        url: '/user/locale',
        method: 'post',
        params: {
          locale: locale
        }
      }).then(response => {
        if (response.data.success) {
          localStorage.setItem('locale', locale)
          this.$i18n.locale = locale
          this.reload()
        } else {
          this.$message.error('Change Language Failed')
        }
      })
    }
  }
}
</script>
<style scoped>
.header {
  float: right;
  height: 48px;
}
.user-center-container {
  height: 48px;
  margin: -5px 20px 0 0;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue